import uuid from '../utils/uuid.utils';

export class PermissionsEvent {
  static PermissionMaxRequestTimes = 2;

  static Resources = {
    CAMERA: 'camera',
    LOCATION: 'location',
    CONTACTS: 'contacts',
  };

  static Status = {
    DENIED: 'denied',
    GRANTED: 'granted',
    ASK_AGAIN: 'ask_again',
  };

  static Action = {
    ASK: 'ask',
    OPEN_SETTINGS: 'open_settings',
  };

  static check(permission, action = null, extraData = {}) {
    window.__CAAS__.triggerNative(
      window.__CAAS__.events.requestPermission,
      uuid(),
      {
        ...extraData,
        permission,
        action,
      },
    );
  }
}
